export const STORAGE_PRODUCTS_CART = "productsCart";
export const TOKEN = "token";
export const siteURL = "https://marykay.com.gt";
export const jwtPart = "/wp-json/jwt-auth/v1/token";
export const woocomPart = "/wp-json/wc/v3/";
export const consumerKey = "ck_20a678fa5b0ca609e4805492dd21a0eb13579b0c";
export const consumerSecret = "cs_020f5601776199dda14106d220b4ccfebb8a6478";
export const cartlink = "/wp-json/cocart/v1/add-item";
export const JWT_KEY =")g}SPKO0P!K?zydHx4?h<-rks5G5^Iu~||&VSH@_(ulK qTS?kuP%HTlT00teA2r";
export const cartLinkVerCarrito = "/wp-json/cocart/v1/";